import PropTypes from "prop-types";
import { langComponent, PAGE_STATE } from "../../../constants/index.jsx";
import Overlay from "../../Overlay/index.jsx";
import React, { useContext, useState } from "react";
import AppContext from "../../../AppContext.jsx";
import { ReactComponent as CloseSvg } from "../../../assets/admin/close.svg";
import ImageCropperEx from "../../common/ImageCropperEx";
import Button from "../../common/Button/index.jsx";
import useScreenSize from "../../../hooks/useScreenSize.js";
import { toast } from "react-toastify";

const UploadModal = ({
  onClose,
  onSuccess,
  aspectRatio,
  circularCrop,
  type = "avatar",
}) => {
  const [pageState, setPageState] = useState(PAGE_STATE.IDLE);
  const { getLang } = useContext(AppContext);
  const TranslationCommon = getLang(langComponent.common);
  const [blob, setBlob] = useState(undefined);
  const [file, setFile] = useState(undefined);

  const handleCompleteCrop = (image) => {
    if (image.blob && image.crop) {
      const file = new File([image.blob], image.file.name);
      setFile(file);
      return;
    }

    setFile(image.file);
  };

  const handleDeleteCrop = () => {
    setFile(undefined);
  };

  const handelUpload = async () => {
    if (!file) {
      toast.error("No image to upload!");
      return;
    }

    return onSuccess(file);
  };

  const prefix = "profile-modal";

  if (pageState === PAGE_STATE.LOADING) {
    return <Overlay />;
  }
  return (
    <Overlay onClose={onClose}>
      <div className={prefix}>
        <div
          className={`${prefix}-content`}
          style={{
            maxWidth: type === "avatar" ? 320 : 640,
          }}
        >
          <div className={`${prefix}-content__header`}>
            {TranslationCommon("Upload Image")}
          </div>
          <div className={`${prefix}-content__uploader`}>
            <ImageCropperEx
              aspectRatio={aspectRatio}
              name={"profile"}
              multiple={false}
              onChange={(images) => {
                if (!images || images.length === 0) {
                  handleDeleteCrop();
                  return;
                }

                handleCompleteCrop(images[0]);
              }}
              cropperHeight={320}
              defaultImages={undefined}
              circular={circularCrop}
            />
          </div>

          <div className={`${prefix}-content__action`}>
            <Button
              label={TranslationCommon("Close")}
              onClick={onClose}
              size="small"
              variant="secondary"
            />
            <Button
              label={TranslationCommon("Upload")}
              onClick={handelUpload}
              size="small"
            />
          </div>
        </div>
      </div>
    </Overlay>
  );
};

UploadModal.PropTypes = {
  onClose: PropTypes.func,
  onSuccess: PropTypes.func,
  aspectRatio: PropTypes.number,
  circularCrop: PropTypes.bool,
};

UploadModal.defaultProps = {
  onClose: () => {},
  onSuccess: () => {},
  editing: undefined,
  aspectRatio: 1,
  circularCrop: false,
};

export default UploadModal;
